module.exports = __webpack_public_path__ + "static/img/jskffm.0c162e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jskffm.jpg
// module id = vBXA
// module chunks = 31